var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnhanceDecisionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "EnhanceDecisions_icon_svg__a",
    d: "M0 60h60.153V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.526 34.737C50.526 48.689 39.216 60 25.263 60 11.311 60 0 48.69 0 34.737 0 20.784 11.31 9.474 25.263 9.474c13.953 0 25.263 11.31 25.263 25.263",
    fill: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "EnhanceDecisions_icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#EnhanceDecisions_icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#EnhanceDecisions_icon_svg__b)",
    d: "M23.158 31.579h9.474V17.895h-9.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21 30.526h7.369V18.947H24.21v11.58zm8.422 2.106h-9.474c-.581 0-1.053-.47-1.053-1.053V17.895c0-.582.472-1.053 1.053-1.053h9.474c.58 0 1.052.47 1.052 1.053v13.684c0 .582-.471 1.053-1.052 1.053z",
    fill: "#EE4900",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#EnhanceDecisions_icon_svg__b)",
    d: "M32.632 31.579h9.473V1.053h-9.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.684 30.526h7.369V2.106h-7.369v28.42zm8.421 2.106h-9.473c-.581 0-1.053-.47-1.053-1.053V1.053C31.579.47 32.05 0 32.632 0h9.473c.581 0 1.053.47 1.053 1.053v30.526c0 .582-.472 1.053-1.053 1.053z",
    fill: "#EE4900",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#EnhanceDecisions_icon_svg__b)",
    d: "M42.105 31.579h9.474v-20h-9.474z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.158 30.526h7.368V12.632h-7.368v17.894zm8.42 2.106h-9.473c-.58 0-1.052-.47-1.052-1.053v-20c0-.582.471-1.053 1.052-1.053h9.474c.581 0 1.053.47 1.053 1.053v20c0 .582-.472 1.053-1.053 1.053z",
    fill: "#EE4900",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.526 28.421l-6.52 4.176a3.15 3.15 0 00-2.953-2.07h-6.316c-1.448 0-3.649-2.106-5.392-2.106h-6.187c-2.544 0-5.035 1.965-6.316 3.158-1.979 1.979-5.75 5.857-6.316 6.316 3.148 2.722 9.08 8.612 10.527 9.888 1.956-1.957 2.722-3.572 4.339-3.572h15.66c1.468-.82 10.527-8.422 10.527-8.422s6.15-6.623 7.368-9.473c-.765-1.03-5.526-2.565-8.42 2.105",
    fill: "#FFF",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.086 37.867c1.919 1.723 4.431 4.14 6.508 6.136.936.9 1.788 1.719 2.41 2.305.244-.27.468-.527.679-.77 1.111-1.277 2.07-2.38 3.708-2.38h15.363c1.429-.951 6.689-5.271 10.098-8.132 1.54-1.663 5.328-5.958 6.749-8.39-.487-.211-1.267-.41-2.18-.345-1.12.086-2.721.622-4 2.684l-.126.203-6.076 3.89a4.215 4.215 0 01-4.165 4.825l-10.527.001V35.79h10.526a2.107 2.107 0 002.106-2.105c0-1.16-.945-2.106-2.106-2.106h-6.316c-.963 0-1.934-.539-2.964-1.11-.838-.466-1.788-.995-2.428-.995h-6.186c-2.187 0-4.447 1.802-5.6 2.876-.617.619-1.453 1.465-2.306 2.33a354.493 354.493 0 01-3.167 3.188zm9.013 11.36l-.743-.654c-.566-.5-1.737-1.626-3.222-3.052-2.39-2.3-5.364-5.16-7.297-6.83l-.949-.822.975-.792c.336-.272 2.308-2.27 3.892-3.878.856-.867 1.695-1.716 2.344-2.365 1.405-1.31 4.152-3.466 7.06-3.466h6.186c1.185 0 2.337.64 3.45 1.259.715.397 1.525.846 1.942.846h6.316c1.352 0 2.556.641 3.328 1.634l5.383-3.448c1.408-2.151 3.438-3.385 5.737-3.482 1.754-.058 3.599.577 4.291 1.512l.361.485-.238.555c-1.275 2.985-7.308 9.5-7.565 9.777l-.094.09c-.935.785-9.18 7.692-10.691 8.533l-.24.134H25.392c-.65 0-1.146.538-2.12 1.658a30.368 30.368 0 01-1.474 1.607l-.698.7z",
    fill: "#EE4900",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4A27F",
    mask: "url(#EnhanceDecisions_icon_svg__b)",
    d: "M17.683 54.761l6.54-6.542L9.696 33.694l-6.54 6.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.647 40.236l13.036 13.037 5.05-5.054L9.698 35.183l-5.05 5.053zM17.683 56.25L1.67 40.236l8.027-8.03 16.014 16.013-8.028 8.031z",
    fill: "#EE4900",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.58 43.158a1.05 1.05 0 01-.745-.309L8.73 40.744a1.051 1.051 0 111.488-1.488l2.105 2.105a1.051 1.051 0 01-.744 1.797",
    fill: "#EE4900",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.684 27.368c-.58 0-1.052-.47-1.052-1.052V20a1.052 1.052 0 112.105 0v6.316c0 .582-.472 1.052-1.053 1.052",
    fill: "#999",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.842 24.21h-6.315a1.052 1.052 0 110-2.105h6.315a1.052 1.052 0 110 2.105M16.842 16.842c-.58 0-1.052-.47-1.052-1.053V9.474a1.052 1.052 0 112.105 0v6.315c0 .582-.472 1.053-1.053 1.053",
    fill: "#999",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13.684h-6.316a1.052 1.052 0 110-2.105H20a1.052 1.052 0 110 2.105M5.263 18.947c-.58 0-1.052-.47-1.052-1.052v-6.316a1.052 1.052 0 112.105 0v6.316c0 .582-.472 1.052-1.053 1.052",
    fill: "#999",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.421 15.79H2.105a1.052 1.052 0 110-2.106h6.316a1.052 1.052 0 110 2.105",
    fill: "#999",
    mask: "url(#EnhanceDecisions_icon_svg__b)"
  }))));
}
export default SvgEnhanceDecisionsIcon;